import { Moment } from 'moment'

import { BaseModel } from './base.model'
import { Program } from './program.model'

export class DeviceActivation extends BaseModel<DeviceActivation> {
  static DEFAULT_ATTRIBUTES = {}

  centerId: number
  centerName: string
  createdAt: Moment
  current: boolean
  deviceId: number
  deviceUid: string
  deviceNumber: string
  deviceAppVersion: string
  deviceAppPackageId: number
  id: number
  programs: Program[]
  userFullname: string
  userId: number
  revokedAt: Moment

  revokeState(): string {
    if (this.revokedAt){
      return 'Разблокировать'
    }
    else{
      return 'Заблокировать'
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/device-activation.model.ts